import React from 'react';
import { Col, Form, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import useInvoiceMonthlies from '../../../useInvoiceMonthlies';
import Helpers from 'helpers';
import { renderGroupedShopOptions } from 'components/shopOptions';
import moment from 'moment';

const InfoSection = ({ shops, inactiveShops, isNew, period }) => {
  const { t } = useTranslation();
  const { singleItem } = useInvoiceMonthlies();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Data caricamento')} name='period'>
          {period}
          {/* <Input
            style={{ width: '100%' }}
            disabled={true}
          /> */}
          {/*<DatePicker*/}
          {/*  disabled={!isNew}*/}
          {/*  format={'DD MMMM YYYY'}*/}
          {/*  style={{ width: '100%' }}*/}
          {/*/>*/}
        </Form.Item>
        <Form.Item label={t('Data del fatturato')} name='period'>
          {singleItem?.periodNormal &&
            moment(singleItem.periodNormal).format('MM/YYYY')}
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item
          label={t('Insegna')}
          name='company_id'
          optionFilterProp={'label'}
        >
          <Select
            disabled={!isNew}
            placeholder={t('Insegna')}
            {...Helpers.addSearchProps()}
          >
            {renderGroupedShopOptions({
              shops,
              inactiveShops,
              t,
            })}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
